module.exports = "/assets/storybook/reservation-card-1-1.jpg?v5Uri3F";